module.exports = __webpack_public_path__ + "1-9be07ad8.worker.js"